<template>
  <div class="ly-rich-text">
    <!-- 列表 -->
    <fh-ellipsis v-if="isSingleLine" :content="fielterText" />
    <template v-else>
      <!-- 详情 -->
      <!-- <jw-tooltip v-if="!tooltipDisableed" popup-container="body" position="top" content-class="jw-tooltip-scroll" :content-style="{ padding: '8px 6px 8px 12px' }">
        <template #content>
          <div v-html="fielterText"></div>
        </template>
        <div @click="handleMouseOver" class="editor-text" :class="{ 'single-line': isSingleLine }" v-html="fielterText"></div>
      </jw-tooltip> -->
      <div @click="handleMouseOver" v-html="fielterText" :class="[isMaxHeight ? 'follow-editor-text' : 'editor-text', { 'single-line': isSingleLine, 'task-rich': isTask }]"></div>
      <div v-html="fielterText" ref="holderDivRef" class="holder-div"></div>
      <jw-image-preview-group v-model:visible="imgVisible" v-model:current="currentImg" infinite :srcList="imgSrcArray" show-loader />
    </template>
  </div>
</template>

<script setup>
import { computed, ref, nextTick } from 'vue';
import { tools } from '@/utils/tools.js';
import { feishuService } from '@/api/';
import useFeishuSDK from '@/hooks/feishu-sdk.js';
import { Message } from '@arco-design/web-vue';
import { useUserStore } from '@/store';
import FhEllipsis from '@/components/fh-ellipsis/index.vue';
const userStore = useUserStore();
const props = defineProps({
  fieldValue: String,
  isTask: {
    /* 是否是任务流程中 */
    type: Boolean,
    default: false
  },
  isSingleLine: {
    // 是否单行展示
    type: Boolean,
    default: true
  },
  isMaxHeight: {
    // 取消最大高度
    type: Boolean,
    default: false
  },
  rowHeight: {
    type: Number,
    default: 0
  },
  sourceType: {
    //1：快捷编辑的展示，
    type: String || Number,
    default: 0
  }
});
const newFieldValue = computed(() => props.fieldValue);

const fielterText = computed(() => {
  let result = newFieldValue.value;
  if (!result) return props?.sourceType ? '' : '-';
  // 如果是单行文本则去掉所有换行和空格 以及所有的换行标签、p标签
  if (props?.isSingleLine) {
    result = tools.handleRichText(result);
  }

  result = result.replace(/<img/g, '&nbsp;&nbsp;<img class="rich-text-img" height="60"');
  // 去除img标签内联样式，避免影响详情页展示
  result = result.replace(/<img[^>]*style="[^"]*"[^>]*>/gi, function (match) {
    return match.replace(/ style="[^"]*"/gi, '');
  });
  return result;
});
const imgSrcArray = computed(() => {
  const htmlString = newFieldValue.value;
  // 创建一个新的 DOMParser 实例
  const parser = new DOMParser();
  // 使用 DOMParser 解析字符串为文档对象
  const doc = parser.parseFromString(htmlString, 'text/html');
  // 获取所有的 img 标签
  const imgElements = doc.getElementsByTagName('img');
  // 提取 img 标签的 src 属性并放入数组
  const srcArray = Array.from(imgElements).map((img) => img.src);
  return srcArray;
});
const imgVisible = ref(false); // 图片预览
const currentImg = ref(0); // 图片预览当前图片下标
// 富文本图片预览
const previewImage = (src) => {
  currentImg.value = imgSrcArray.value.findIndex((item) => item == src) || 0;
  imgVisible.value = true;
  // // 创建预览元素
  // const preview = document.createElement('div');
  // preview.style.position = 'fixed';
  // preview.style.top = '0';
  // preview.style.left = '0';
  // preview.style.width = '100%';
  // preview.style.height = '100%';
  // preview.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
  // preview.style.display = 'flex';
  // preview.style.justifyContent = 'center';
  // preview.style.alignItems = 'center';
  // preview.style.zIndex = '10000';

  // const img = document.createElement('img');
  // img.src = src;
  // img.style.maxWidth = '90%';
  // img.style.maxHeight = '90%';
  // img.style.objectFit = 'contain';

  // // 点击预览区域时关闭预览
  // preview.onclick = () => {
  //   preview.remove();
  // };

  // preview.appendChild(img);
  // document.body.appendChild(preview);
};
// 富文本缩略图触发事件
const handleMouseOver = (event) => {
  // 检查事件目标是否是图片
  if (event.target.tagName === 'IMG' && event.target.classList.contains('rich-text-img')) {
    event.stopPropagation();
    previewImage(event.target.src);
  } else if (event?.target?.attributes?.['data-w-e-type']?.value == 'mention') {
    //点击人员事件
    mouseenter(event);
  }
};
// console.log(handleMouseOver);
const mouseenter = async (e) => {
  console.log(77, e);

  // timer && clearTimeout(timer);
  // leaveTimer && clearTimeout(leaveTimer);
  let dom = '';
  if (e?.target?.attributes?.['data-w-e-type']?.value == 'mention') dom = e?.target;
  console.log(76, dom);
  const userId = e?.target?.dataset?.userId || '';
  console.log('人员组件接受', userId);
  if (userId) {
    // 获取当前用户的飞书openId
    if (!userStore.userInfo?.feishuOpenId) return false;
    // 获取用户的openId
    const viewUser = await feishuService.getUserOpenId({ userId });
    if (!viewUser.result) {
      Message.warning('Ta不是飞书成员，无法查看飞书名片');
      return false;
    }
    // 获取用户的openId
    const openId = viewUser.result?.openId;
    console.log(301, openId, viewUser.result);
    closeProfile();
    await useFeishuSDK({ isComponent: 1, userId, openId });
    const dom = document.querySelector('#userProfile');
    var top = e.y;
    var left = e.x;
    // 宽度：
    var w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    // 高度：
    var h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

    if (w - e.x < 320) {
      left -= 320;
    }
    if (h - e.y < 520) {
      top -= 520;
    }
    if (left < 0) left = 0;
    if (top < 0) top = 0;
    left += 30;
    dom.style.left = left + 'px';
    if (h - e.y > 0) {
      dom.style.top = top + 'px';
    } else {
      dom.style.bottom = 0 + 'px';
    }
    // window.removeProfileDynamical?.();
    window.removeProfileDynamical?.();
    nextTick(() => {
      window.addProfileDynamical?.();
    });
  }
  // }, 800);
};
const closeProfile = () => {
  // if (!(e?.target?.className?.indexOf('comp-xl-avatar') > -1 || e?.target.parentNode?.className?.indexOf('comp-xl-avatar') > -1 || e?.target.parentNode?.parentNode?.className?.indexOf('comp-xl-avatar') > -1 || e?.target.parentNode?.parentNode?.parentNode?.className?.indexOf('comp-xl-avatar') > -1)) {
  window.removeProfileDynamical?.();
  const dom = document.querySelector('#userProfile');
  dom.innerHTML = '';
  nextTick(() => {
    window.removeProfileDynamical?.();
    dom.innerHTML = '';
  });
  // }
};

const holderDivRef = ref(null);
//#region 是否禁用tooltip 默认禁用
// const tooltipDisableed = ref(true);
// const checkTooltipDis = () => {
//   if (holderDivRef.value) {
//     tooltipDisableed.value = !(holderDivRef.value.scrollWidth > holderDivRef.value.clientWidth && props.isSingleLine);
//   } else {
//     tooltipDisableed.value = true;
//   }
// };
// onMounted(() => {
//   checkTooltipDis();
// });

// onUpdated(() => {
//   nextTick(() => {
//     checkTooltipDis();
//   });
// });
//#endregion
</script>
<style scoped lang="less">
@import './ly-rich-text.less';
</style>
